/**
 * Gets privacy rights blocked cookies levels mapper and ensures that level 1 cookies,
 * mandatory cookies, are not included.
 *
 * @returns {Object} privacy rights blocked cookies levels mapper
 */
function getPrivacyRightsBlockedCookiesLevelsMapper() {
    const {ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER} = window.SitePreferences;
    const mapper = {};

    Object.keys(ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER).forEach(right => {
        mapper[right] = ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER[right].filter(
            blockedLevel => blockedLevel !== 1
        );
    });

    return mapper;
}

/**
 * Gets blocked cookies levels for the given Privacy rights request types
 *
 * @param {Array} requestTypes - Privacy rights request type
 * @returns {Set} blocked cookies levels set
 */
function getBlockedCookiesLevels(requestTypes) {
    const ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER = getPrivacyRightsBlockedCookiesLevelsMapper();
    let blockedCookiesLevels = [];
    let blockedLevelsForRequestType;

    requestTypes.forEach(requestType => {
        blockedLevelsForRequestType = ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER[requestType] || [];
        blockedCookiesLevels = blockedCookiesLevels.concat(blockedLevelsForRequestType);
    });

    return new Set(blockedCookiesLevels);
}

/**
 * Updates the privacy setting (privacy cookie and session variables)
 *
 * @param {Array} requestTypes - Privacy rights request types
 * @returns {void}
 */
function updatePrivacySetting(requestTypes) {
    if (!requestTypes || !requestTypes.length) {
        return;
    }

    const blockedLevels = getBlockedCookiesLevels(requestTypes);

    if (!blockedLevels.size) {
        return;
    }

    const allowedLevels = [1, 2, 3]
        .filter(level => !blockedLevels.has(level))
        .map(level => `level${level}`)
        .join(',');
    const {COOKIE_PRIVACY_SETTING} = window.SitePreferences;
    const disallowedCookies = [];
    const allowedCookies = [];
    let cookieLevel;

    for (const cookieName in COOKIE_PRIVACY_SETTING) {
        if (Object.prototype.hasOwnProperty.call(COOKIE_PRIVACY_SETTING, cookieName)) {
            cookieLevel = COOKIE_PRIVACY_SETTING[cookieName];

            if (blockedLevels.has(cookieLevel)) {
                disallowedCookies.push(cookieName);
            } else {
                allowedCookies.push(cookieName);
            }
        }
    }

    const cookieData = {
        disallow: disallowedCookies.join(','),
        allow: allowedCookies.join(','),
        levels: allowedLevels
    };

    $.ajax({
        type: 'POST',
        url: Urls.updatePrivacyCookie,
        data: cookieData
    });
}

/* eslint-disable import/prefer-default-export */
/**
 * Initializes oneTrust component
 *
 * @returns {void}
 */
export const init = () => {
    window.addEventListener('message', function (event) {
        const ONE_TRUST_ORIGIN = 'https://privacyportal.onetrust.com';

        if (
            event.origin !== ONE_TRUST_ORIGIN ||
            !window.SitePreferences ||
            !window.SitePreferences.COOKIE_PRIVACY_SETTING ||
            !window.SitePreferences.ONE_TRUST_PRIVACY_RIGHTS_BLOCKED_COOKIES_LEVELS_MAPPER
        ) {
            return;
        }

        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
        try {
            const eventData = JSON.parse(event.data);
            updatePrivacySetting(eventData.requestTypes);
        } catch (error) {}
    });
};
